import { R_BLOG, R_BLOG_DETAILS } from '../routes';

const Blog = () => import(/* webpackChunkName: "Blog" */ '@/views/Blog');
const BlogDetails = () => import(/* webpackChunkName: "BlogDetails" */ '@/components/Blog/BlogDetails');

export default {
  path: '/blog',
  component: {
    render(c) {
      return c('router-view');
    },
  },
  children: [
    {
      name: R_BLOG,
      path: '',
      meta: {
        title: 'Blog',
      },
      component: Blog,
    },
    {
      name: R_BLOG_DETAILS,
      meta: {
        title: 'Blog',
      },
      path: 'details',
      component: BlogDetails,
    },
  ],
};
